import { render, staticRenderFns } from "./HistoricoDeCobranca.vue?vue&type=template&id=6530c574&scoped=true&"
import script from "./HistoricoDeCobranca.vue?vue&type=script&lang=js&"
export * from "./HistoricoDeCobranca.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoDeCobranca.vue?vue&type=style&index=0&id=6530c574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530c574",
  null
  
)

export default component.exports